import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { ChevronLeftIcon, FolderOpenIcon } from "@heroicons/react/20/solid";
import { useRouter } from 'next/router';

type OpendataProps = ComponentProps & {
  fields: {
    heading: Field<string>;
    title: {
      value: string
    },
    titleSection: {
      value: string
    },
    childItems: any[]

  };
  locale: string,
  lang: string
};

const Opendata = (props: OpendataProps): JSX.Element => {
  const router = useRouter();

  return (
    <div className={`responsive lg:py-40 py-28 ${props?.locale == "ar" ? 'rtl' : ''}`}>
      <div className='flex gap-2 -ml-[6px] items-center'>
        <ChevronLeftIcon onClick={() => { router.back() }} className={` cursor-pointer w-7 h-7 ${props?.locale == "ar" && "rotate-180"}`}
          aria-hidden="true"
        />
        <h1 className={`text-[42px] text-brand-100 font-bold animate-top-dga`}>{props.fields.title.value}</h1>
      </div>

      <div>
        <h1 className={`text-[28px] text-[#003141] font-bold  lg:mt-11 mt-8 mb-8 animate-top-dga`}>{props.fields.titleSection.value}</h1>
      </div>



      <div className='grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10'>
        {props?.fields?.childItems?.length > 0 && props?.fields?.childItems?.map((item: any, index: number) => {
          return (
            <div className='col-span-1  gap-4 flex flex-col animate-top-dga' key={index}>
              <div className='bg-[#F2F2F2] py-20 flex justify-center items-center'>
                <FolderOpenIcon className=' w-20 h-20 text-[#B7B7B7]'
                  aria-hidden="true"
                />
              </div>
              <div className='flex gap-3 justify-between  '>
                <p className='color-[#2E2E2E] text-[18px] font-medium'>{item?.fields?.title?.value}</p>
                <a href={item?.fields?.file?.value?.src} className=' w-6 h-6' download>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                    <path
                      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                      stroke="#423C3C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7 10L12 15L17 10"
                      stroke="#423C3C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 15V3"
                      stroke="#423C3C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
}

export default withDatasourceCheck()<OpendataProps>(Opendata);
